let datadogRumModulePromise: Promise<typeof import('@datadog/browser-rum')> | null = null;

export function loadDatadogRum() {
  datadogRumModulePromise ??= import('@datadog/browser-rum');
  return datadogRumModulePromise;
}
